<template>
  <el-dialog custom-class="list-dialog" :title="title" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :modal="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="4">
          <el-input v-model="customername" placeholder="请选择门店"
                    @click.native="showSelectAllCustomerName" @clear="clearCustomerName" :clearable="true"></el-input>
        </el-col>
        <el-col :span="3">
          <CommonTree ref="treeDserial" :treeHeight="180" :searchText="serveuname" @check="changeServer"
                      style="width: 170px"
                      :isShowCheckBox="false"></CommonTree>
        </el-col>
        <el-col :span="5">
          <el-date-picker style="width:120px"
                          v-model="searchbegindate" :value-format="'yyyy-MM-dd'"
                          type="date"
                          placeholder="开始日期">
          </el-date-picker>
          <el-date-picker style="width:120px"
                          v-model="searchenddate" :value-format="'yyyy-MM-dd'"
                          type="date"
                          placeholder="结束日期">
          </el-date-picker>
        </el-col>
        <el-col :span="2">
          <el-button type="warning" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="warning" v-on:click="add">新增</el-button>
        </el-col>
        <!--<el-col :span="2">-->
          <!--<el-button type="warning" v-on:click="bindGrid(null,true)">导出</el-button>-->
        <!--</el-col>-->
        <el-col :span="2">
          <el-button type="warning" v-on:click="lookCouponLog">日志</el-button>
        </el-col>
      </el-col>
    </div>

    <ExternaldeptSel ref="externaldeptsel" @select="afterSelExternalDept"></ExternaldeptSel>


    <el-col :span="24">
      <div>
        <el-table
          :data="tableData"
          :height="tableHeight(155)"
          size="mini"
          border
          stripe
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>
          <el-table-column
            prop="uname"
            label="发放人"
            align="center"
            header-align="center" width="90"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="adddate"
            label="日期"
            align="center"
            header-align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="customerserial"
            label="客户编码"
            align="left"
            header-align="center" width="110"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="customername"
            label="所属客户"
            align="left"
            header-align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
            prop="serveuname"
            label="业务员"
            align="left" width="90"
            :show-overflow-tooltip="true"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="money"
            label="总额"
            align="left"
            width="90"
            header-align="center"
          >
            <template slot-scope="scope">
              {{scope.row.money | numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="handleovermoney"
            label="已使用"
            align="left"
            header-align="center"
            width="90">
            <template slot-scope="scope">
            {{scope.row.handleovermoney | numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            width="90"
            prop="hasused"
            label="是否用完"
            align="center"
            header-align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.hasused==0">未用完</div>
              <div v-if="scope.row.hasused==1">已用完</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="用完时间">
            <template slot-scope="scope">
              {{(scope.row.useddate || "").substr(0, 10)}}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="260" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger" v-if="scope.row.hasused==0"
                @click="handleEditEnd(scope.$index, scope.row)">作废
              </el-button>
              <el-button
                size="mini"
                @click="handleLook(scope.$index, scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <MachinecouponDialog ref="DataContactAddEdit" @bindGrid="bindGrid"></MachinecouponDialog>
        <GivecouponlogList ref="GivecouponlogList" @bindGrid="bindGrid"></GivecouponlogList>
        <MachinecouponhisList ref="MachinecouponhisList" :combo="true"></MachinecouponhisList>
        <SaleTimeEdit ref="SaleTimeEdit" @bindGrid="bindGrid"></SaleTimeEdit>
        <Userecordt ref="userecordtlook"></Userecordt>
        <div class="foot" :style="{textAlign:'center' }">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
      </div>
    </el-col>
  </el-dialog>
</template>


<script>
  import {getListData, machImport} from '@/api/set/machinecoupon'
  import {ListData, saleImport, saleRemove} from '@/api/set/salecoupon'
  import MachinecouponDialog from './MachinecouponDialog'
  import SaleTimeEdit from './SaleTimeEdit'
  import Userecordt from './Userecordt'
  import GivecouponlogList from './GivecouponlogList'
  import MachinecouponhisList from './MachinecouponhisList'
  import ExternaldeptSel from '@/components/set/externaldept/ExternaldeptSel'

  export default {
    name: "SalecomboEdit",
    data() {
      return {
        dialogFormVisible: false,
        formLabelWidth: '120px',
        isClickEvent: true,//选择供应商、客户清空图标按钮不触发click事件使用
        title: '',
        customername: '',//客户名称
        customerserial: '',//客户编码
        serveuname:'',
        serveuguid:'',
        exceltableData:[],
        flag: false,
        form: {
          unitguid: ''//关联优惠策略
        },
        tableData: [],//优惠券赠送明细
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        begindate: '',//开始时间
        enddate: '',//结束时间
        searchbegindate:'',
        searchenddate:'',
        storeInfo: {
          coupon: 'coupon',
          province: '',
          city: '',
          county: '',
          independentserial: ''
        }//优惠券的地址和独立核算部门
      }
    },
    methods: {

      handleEditEnd(index, row){
        this.$refs.SaleTimeEdit.show(row,'over')
      },
      //销售客服选择后
      changeServer(guids, names, arr) {
        this.serveuguid = guids;
        this.serveuname = names;
      },

      excelPort() {
        let data = []
        for (let i in this.exceltableData) {
          data.push(Object.assign({}, this.exceltableData[i]))
        }
        let header1 = ''
        let column1 = ''
        header1 = ["发放人", "日期", "客户编码", "所属客户", "业务员", "金额", "开始日期","截止日期", "已使用金额","状态", "用完时间"]
        column1 = ["uname", "adddate", "customerserial", "customername", "serveuname", "money", "begindate", "enddate", "handleovermoney", "hasused", "useddate"]

        var name = new Date();
        name = "现金抵扣券" + this.fmtDate(name);
        let heji = {}
        let totalnumber = 0, salemoney = 0
        for (let i = 0; i < data.length; i++) {
          data[i]["hasused"]=data[i]["hasused"]==1?'已用完':'未用完'
          totalnumber +1;
          salemoney = salemoney + (data[i]["money"] || 0)

          data[i]["money"] = (Math.round(data[i]["money"] * 100) / 100).toFixed(2)
        }
        heji["uname"] = "合计"
        heji["customername"] = totalnumber
        heji["money"] = (Math.round(salemoney * 100) / 100).toFixed(2)
        data.push(heji)

        this.$exportExcel(header1, column1, data, name)
      },
      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      },
      //查看每张券都能查看使用日志
      handleLook(index, row) {
        this.$refs.MachinecouponhisList.show(this.title)
        this.$refs.MachinecouponhisList.initData(row.unitguid)
      },
      //查看优惠券赠送日志
      lookCouponLog() {
        this.$refs.GivecouponlogList.show(this.title);
        this.$refs.GivecouponlogList.initData(this.form.unitguid);
      },
      show(title, row) {
        this.tableData = []//优惠券赠送明细
        this.title = title;//页面标题
        this.begindate = row.begindate.substr(0, 10)//开始时间
        this.enddate = row.enddate.substr(0, 10)//结束时间
        this.storeInfo.province = row.province
        this.storeInfo.city = row.city
        this.storeInfo.county = row.county
        this.storeInfo.independentserial = row.independentserial
        this.dialogFormVisible = true;
      },
      //控制新增按钮显示和隐藏
      addHidden() {
        //开始、结束时间转数组
        var beginDate = this.begindate.split("-");
        var endDate = this.enddate.split("-");
        //开始、结束转时间格式
        var beginFormatting = new Date(beginDate[0], parseInt(beginDate[1]) - 1, beginDate[2])
        var endFormatting = new Date(endDate[0], parseInt(endDate[1]) - 1, endDate[2])
        //开始、结束时间跟当前时间比较
        return beginFormatting <= new Date() && endFormatting >= new Date()
      },
      initForm(unitguid) {
        //根据外键获取数据
      },
      add() {
          this.$refs.DataContactAddEdit.show();
          this.$refs.DataContactAddEdit.initForm(this.form.unitguid, this.storeInfo, this.title);
      },

      selExternal() {
        this.$refs.externalsel.show()
      },
      selectExternalDept(customerserial, deptname, row) {
        this.customerserial = customerserial;
        this.customername = deptname;
        this.flag = true;
      },
      bindGrid(unitguid,loadexcel) {
        if (unitguid !== undefined&&unitguid) {
          this.form.unitguid = unitguid;
        }

        if (!this.form.unitguid) {
          this.form.unitguid = '';
        }
        if (!this.customerserial) {
          this.customerserial = ''
        }
        var offset=(this.pagination.currentPage - 1) * this.pagination.pageSize;
        var limit=this.pagination.pageSize;
        if(loadexcel){
          offset=0;
          limit=10000;
        }

          getListData({
            offset: offset,
            limit: limit,
            favourunitguid: this.form.unitguid,
            customerserial: this.customerserial,
            serveuguid:this.serveuguid,
            begindate:this.searchbegindate,
            enddate:this.searchenddate,
          }).then(response => {
            if(loadexcel){
              this.exceltableData= response.data.rows
              this.excelPort()
            }else {
              this.tableData = response.data.rows
              this.pagination.total = response.data.total
            }
          }).catch((error) => {
            console.log(error)
          });
      },
      search() {
        this.bindGrid()
      },
      //查询条件的选择门店
      showSelectAllCustomerName() {
        if (this.isClickEvent) {
          this.$refs.externaldeptsel.show(1, '选择门店')
        } else {
          this.isClickEvent = true
        }
      },
      //查询条件的选择供应商或者门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
      },
      clearCustomerName() {
        this.isClickEvent = false
        this.customerserial = "";
      }
    },
    mounted() {
      // this.bindGrid()
    },
    components: {
      MachinecouponDialog,//配送、加工、现金抵扣券赠送页面
      ExternaldeptSel,//客户页面
      SaleTimeEdit,
      Userecordt,//加工券使用记录页面
      GivecouponlogList,//优惠券赠送记录页面
      MachinecouponhisList,//加工券、现金券使用详情
    },
  }
</script>
<style scoped>
  .el-table .success-row {
    background: #f0f9eb;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/salefavour/SalecomboEdit.vue